// Canonical site URL used for <link rel="canonical">, og:url, JSON-LD, etc.
// Production uses apex (mentis-ai.net); www redirects there, so defaults must match.
// Override with REACT_APP_SITE_URL in Netlify (or other host) env if needed.
export const SITE_URL: string = (
  process.env.REACT_APP_SITE_URL || 'https://mentis-ai.net'
).replace(/\/$/, '');

export const SITE_NAME = 'Mentis AI';
export const DEFAULT_OG_IMAGE = '/og-image.png';
export const BRAND_ICON_PATH = '/mentis-icon.png';
export const BRAND_LOGO_PATH = '/mentis-logo.png';

export const buildCanonical = (path: string): string => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized === '/' ? '' : normalized}`;
};

export const absoluteUrl = (pathOrUrl: string): string => {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
};
